export default () => ({
  options: []
});
